import styled from "styled-components";

export const Logo = styled.div`
    display: block;
`